/** @format */
'use client';
import styled from 'styled-components';

// import LoadingSpinner from './LoadingSpinner';

interface CentredLoadingSpinnerProps {
  height?: number;
}

const StyledCentredLoadingSpinner = styled.div<{ height?: number }>`
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center;
  svg {
    height: ${({ height }) => `${height ? height : 50}px`};
  }
`;

function CentredLoadingSpinner(props: CentredLoadingSpinnerProps) {
  return (
    <StyledCentredLoadingSpinner {...props}>
      {/*<LoadingSpinner />*/}
      Loading.....
    </StyledCentredLoadingSpinner>
  );
}

export default CentredLoadingSpinner;
